import React from 'react';
import styled, { keyframes } from 'styled-components';
import Button from './Button';

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const LoaderContainer = styled.span`
  display: inline-flex;
  margin-right: 8px;
`;

const Loader = styled.span`
  width: 24px;
  height: 24px;
  border: 3px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: #ffffff;
  animation: ${spin} 1s ease-in-out infinite;
`;

interface LoadingButtonProps {
  isLoading?: boolean;
  disabled: boolean;
  text: string;
  onClick: () => void;
}

const LoadingButton: React.FC<LoadingButtonProps> = ({
  isLoading = false,
  disabled,
  text,
  onClick
}) => {
  return (
    <Button onClick={onClick} disabled={disabled} className="nav-special-cta">
      {isLoading && (
        <LoaderContainer>
          <Loader />
        </LoaderContainer>
      )}
      {text}
    </Button>
  );
};

export default LoadingButton;
